import { Link } from "react-router-dom"

import style from "./style.module.scss"

export function Service() {
    return (
        <Link
            to="https://psyalter.helpdeskeddy.com/ru/knowledge_base/category/1/"
            target="_blank"
            rel="noopener noreferrer"
            className={style.link}
        >
            Справочный центр
        </Link>
    )
}
